import { Component, ViewChild } from '@angular/core';
import {  ModalController, NavController, NavParams, Searchbar } from 'ionic-angular';
import { ViewController } from 'ionic-angular/navigation/view-controller';
import { BllOrtak } from '../../providers/bll/bll-ortak';
import { Ortak } from '../../providers/ortak';
import { MarkaEklePage } from '../Yonetim/MarkaIslemleri/marka-ekle/marka-ekle';

/**
 * Generated class for the MarkaSecPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */
 
@Component({
  selector: 'page-marka-sec',
  templateUrl: 'marka-sec.html',
})
export class MarkaSecPage {
  aranan = "";
  skip: number = 0;
  take: number = 50;
  cariListesi = [];
  CariID:string;
 
  
  @ViewChild('searchbar') searchbar: Searchbar;
  constructor(public navCtrl: NavController,
    public bllOrtak:BllOrtak,
     public navParams: NavParams,
     public viewCtrl:ViewController,
     public ortak:Ortak,
     public modalCtrl:ModalController) {

  }

  ionViewDidLoad() {
    this.OnlinecariAra();
    // this.girismesaji();

   
  }
  ionViewDidEnter() {
    setTimeout(() => {
      this.searchbar.setFocus();
    });
  }

  girismesaji()
  {
    this.ortak.showBasicAlert("Uyarı","Lütfen Mal Aldığınız Firmayı veya Cari'yi Seçiniz..");
  }
  OnlinecariAra() {
    var formData = new FormData();
    // formData.append("aranan", this.aranan);
    // formData.append("skip", this.skip.toString());
    // formData.append("take", "");
    // formData.append("grupkodu", "-1");
    formData.append("aranan", this.aranan);
    formData.append("skip", "0");
    formData.append("take", "1000");
    this.bllOrtak.islem(formData, "MarkaListesi", "", false).then(a => {
      var sonuc = <any>a;
      this.cariListesi = sonuc.SonucObject;
      this.searchbar.setFocus();
    })
  }
   
  urunler(e) {

    if(this.aranan.length>2)
    {
      this.OnlinecariAra();

    }
    if(this.aranan.length==0)
    {
      this.OnlinecariAra();
    }
  
  }

  yeni()
  {
    let modal = this.modalCtrl.create(MarkaEklePage);
    modal.onDidDismiss(data => {
      this.ionViewDidLoad();
    });

    modal.present();
  }
  CariSec(aktarilacakCariKart) {
    this.viewCtrl.dismiss(aktarilacakCariKart);
 }
 kapat()
 {
   this.viewCtrl.dismiss();
 }
}



// WEBPACK FOOTER //
// ./src/pages/marka-sec/marka-sec.ts